export const LINK_FIELD_NAME = "linkData";

export const LINK_ERROR_MESSAGE = {
  INVALID_URL: "Invalid URL. Please check again.",
};

export const DEBOUNCE_TIME = {
  DEFAULT: 700,
  PASTE: 50,
} as const;
